import React from 'react';
import styled from 'styled-components';
import { CreatorSliderContentfulModel } from 'src/api/models/CreatorsSlider';
import CreatorImages from 'src/molecules/creators/creators.images';

const DynamicCratorsContainer = styled.div`
  max-width: 1440px;
  margin-bottom: 3.75rem;
  text-align: center;
`

export default function getDynamicCreatorsSlider(sliderProps: CreatorSliderContentfulModel): React.ReactNode {
  return (
    <DynamicCratorsContainer>
      <CreatorImages creators={sliderProps.contentfulchildren}/>
    </DynamicCratorsContainer>
  )
}
